module.exports = __webpack_public_path__ + "static/media/sourcetree.e52cd56b.svg";